import { render, staticRenderFns } from "./CSR.vue?vue&type=template&id=12a0367e&scoped=true&"
var script = {}
import style0 from "./CSR.vue?vue&type=style&index=0&id=12a0367e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0367e",
  null
  
)

export default component.exports